/** sub_order_id → list/by-ids 행 (null = 조회 완료했으나 응답에 없음, 재요청 안 함) */
export const subOrderListByIdsCache = new Map();

/** 정렬된 요청 id 집합 키 → 진행 중 Promise (동시 중복 POST 방지) */
export const subOrderListByIdsInflight = new Map();

export function normalizeSubOrderIdForCache(id) {
  if (id == null || id === '') return null;
  return String(id);
}

export function inflightKeyForIds(sortedIds) {
  return sortedIds.join('\u0000');
}

/** 로그아웃 등 — api/index와 무관하게 호출 가능 (순환 참조 방지) */
export function invalidateSubOrderListByIdsCache() {
  subOrderListByIdsCache.clear();
  subOrderListByIdsInflight.clear();
}
